var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2_81517)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#1C1C1C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1586 14.8335H15.2514V18.4788C15.2514 18.6721 15.1691 18.8576 15.0226 18.9943C14.876 19.131 14.6772 19.2078 14.47 19.2078C14.2628 19.2078 14.064 19.131 13.9174 18.9943C13.7709 18.8576 13.6886 18.6721 13.6886 18.4788V14.8335H9.78143C9.57418 14.8335 9.37542 14.7567 9.22888 14.6199C9.08233 14.4832 9 14.2978 9 14.1044C9 13.911 9.08233 13.7256 9.22888 13.5889C9.37542 13.4522 9.57418 13.3753 9.78143 13.3753H13.6886V9.73004C13.6886 9.53668 13.7709 9.35124 13.9174 9.21451C14.064 9.07779 14.2628 9.00098 14.47 9.00098C14.6772 9.00098 14.876 9.07779 15.0226 9.21451C15.1691 9.35124 15.2514 9.53668 15.2514 9.73004V13.3753H19.1586C19.3658 13.3753 19.5646 13.4522 19.7111 13.5889C19.8577 13.7256 19.94 13.911 19.94 14.1044C19.94 14.2978 19.8577 14.4832 19.7111 14.6199C19.5646 14.7567 19.3658 14.8335 19.1586 14.8335Z",
    fill: "url(#paint0_linear_2_81517)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2_81517",
    x: -5,
    y: -4.99902,
    width: 39,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2_81517"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2_81517",
    result: "effect2_innerShadow_2_81517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_81517",
    x1: 14.47,
    y1: 7.16374,
    x2: 14.47,
    y2: 20.8409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.38bd329370b50eb5aed91ba3613fb5de.svg";
export { ForwardRef as ReactComponent };